"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetSelectedOfferItems = void 0;
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _constants = require("../constants");
var _constants2 = require("./constants");
// istanbul ignore file -- api
const useGetSelectedOfferItems = (param)=>{
    let { offerId } = param;
    const { tenant } = (0, _environment.useEnvironment)();
    const sessionId = (0, _shoppingContext.useSessionId)();
    const enabled = !!sessionId;
    const { data: { collection } = {}, isValidating, mutate } = (0, _globalApiClientReact.useGetShoppingSessionOfferOfferItems)(sessionId, offerId, {
        isPurchased: true,
        top: _constants.SELECTED_OFFER_ITEMS_TOP_LIMIT
    }, {
        [_fetching.TENANT_CONTEXT]: tenant
    }, {
        swr: {
            enabled,
            // fix type in utils
            ...(0, _constants2.getRetryErrorSwrOptions)()
        }
    });
    const revalidate = (0, _react.useCallback)(async ()=>{
        await mutate();
    }, [
        mutate
    ]);
    return (0, _react.useMemo)(()=>({
            loading: isValidating,
            selectedOfferItems: collection !== null && collection !== void 0 ? collection : [],
            revalidate
        }), [
        collection,
        isValidating,
        revalidate
    ]);
};
exports.useGetSelectedOfferItems = useGetSelectedOfferItems;
